import { index as searchApi } from '@afosto/content/api/Index';

const searchCancelTokens = {};

export const searchRequest = ({ namespace = 'default', code, model }) => async (
  searchContext,
  options = {
    shouldCancel: false,
  },
) => {
  try {
    const tokenKey = `${namespace}-${code}-${model}`;

    if (options.shouldCancel && searchCancelTokens[tokenKey]) {
      searchCancelTokens[tokenKey](
        `Cancel previous search call for namespace ${namespace} and code ${code} and model ${model}`,
      );
    }

    const {
      pagination,
      sorting = {},
      filters: filtersModule = {},
      facets = [],
      search: searchModule = {},
      settings = {},
    } = searchContext;
    const { activeSort = [] } = sorting;
    const { activeFilters = [], fixedFilters = [] } = filtersModule;
    const { searchValue, isFuzzy } = searchModule;
    const { ignoreFixedFiltersOnSearch = false } = settings ?? {};

    const formattedFilters = (searchValue?.length > 0 && ignoreFixedFiltersOnSearch
      ? activeFilters
      : [...fixedFilters, ...activeFilters]
    ).reduce((acc, { key, operator, value }) => {
      if (operator === 'between') {
        return [
          ...acc,
          {
            key,
            operator: 'gte',
            values: [value[0]],
          },
          {
            key,
            operator: 'lte',
            values: [value[1]],
          },
        ];
      }

      return [
        ...acc,
        {
          key,
          operator,
          values: value,
        },
      ];
    }, []);
    const missing = formattedFilters
      .filter(({ operator }) => operator === 'missing')
      .map(filter => filter.key);
    const otherFilters = formattedFilters.filter(({ operator }) => operator !== 'missing');

    const response = await searchApi.searchModel(
      namespace,
      code,
      model,
      {
        ...(searchValue?.length
          ? {
              q: [searchValue],
              is_fuzzy: isFuzzy,
            }
          : {}),
        facets,
        missing,
        filter: otherFilters,
        page_cursor: pagination ? pagination.getPageCursor(pagination.activePage) : null,
        limit: pagination ? pagination.itemsPerPage : null,
        sort: !searchValue?.length
          ? activeSort.map(sortOption => ({
              key: sortOption.key,
              order: sortOption.direction,
            }))
          : [],
      },
      {
        cancel: token => {
          if (options.shouldCancel) {
            searchCancelTokens[tokenKey] = token;
          }
        },
      },
    );

    delete searchCancelTokens[tokenKey];

    return response;
  } catch (err) {
    return Promise.reject(err);
  }
};

export default ({ namespace, code, model }) => async (searchContext = {}, options = {}) => {
  try {
    const response = await searchRequest({ namespace, code, model })(searchContext, options);
    const { hits = [] } = response.data || {};
    const { pagination } = searchContext;

    if (pagination) {
      const itemCount = response.headers['x-count'];

      if (itemCount) {
        pagination.setItemCount(parseInt(response.headers['x-count'], 10));
      }

      pagination.setNextPageCursor(response.headers['x-page']);
    }

    return hits.map(hit => ({
      ...hit.filters,
      ...hit.metadata,
      id: hit.reference,
    }));
  } catch (err) {
    return [];
  }
};
